@if (message) {
  <div class="popover arrow-box">
    <div class="popitem">
      <span>
        {{ message }}
      </span>
    </div>
  </div>
}
@if (messages.length === 0) {
  <div>&nbsp;</div>
}
